import serviceBase from 'app/Services/serviceBase'

class PrepublishMembersActions {
  getUsers = (identifier) => {
    let url = `${window._env_.COMMUNITY_API_URL}/pre-publish/members-by-id/${identifier}/list`
    return serviceBase.get(url).then((response) => {
      return response.data
    })
  }

  createUser = (fireDepartmentId, identifier, email) => {
    let url = `${window._env_.COMMUNITY_API_URL}/pre-publish`
    return serviceBase
      .post(url, {
        fireDepartmentId,
        identifier,
        email
      })
      .then((response) => {
        return response.data
      })
  }
  deleteUser = (identifier, emailList) => {
    let url = `${window._env_.COMMUNITY_API_URL}/pre-publish/delete/pre-publish-members`
    return serviceBase
      .post(url, {
        identifier,
        emails: emailList
      })
      .then((response) => {
        return response.data
      })
  }
}

export default new PrepublishMembersActions()
